module.exports = __webpack_public_path__ + "static/media/nf.8b6629d9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nf.svg
// module id = 995
// module chunks = 0